/// <reference types="@types/googlemaps" />
/*global google*/

import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import _ from "lodash";
import { connect } from "react-redux";
import { compose } from "recompose";
import { setExploreSearch, setExploreSearchPin } from 'store/actions';
import { parseGooglePlace } from "api/rex/spatial";
import { StandaloneSearchBox } from '@react-google-maps/api';
import { fitBoundsWithZoom } from 'components/explore/gmap/helpers';

const defaultBoxStyle = {
  boxSizing: `border-box`,
  width: `300px`,
  height: `40px`,
  marginTop: `10px`,
  padding: `0 12px`,
  borderRadius: `3px`,
  boxShadow: `0 2px 4px rgba(0, 0, 0, 0.2)`,
  fontSize: `14px`,
  outline: `none`,
  textOverflow: `ellipses`,
}

const useStyles = makeStyles({
  root: {

  },
  searchBox: {

  },
  clearButtonMobile: {
    position: 'relative', right: 40, top: 5,
    backgroundColor: '#ffffff',
    fontSize: 14,
    "&:hover": {
      backgroundColor: '#efefef',
    }
  },
  clearButton: {
    position: 'absolute', right: 1, top: 11,
    backgroundColor: '#ffffff',
    fontSize: 14,
    "&:hover": {
      backgroundColor: '#efefef',
    }
  },
  normalBox: {
    ...defaultBoxStyle,
    border: `1px solid transparent`,
  },
  enabledBox: {
    ...defaultBoxStyle,
    border: `1px solid #ce2d78`,
  }
});

/*
  Test addresses:
    6902 star dr              ExplorePropertyId = 24420162
    6807 CIRCLE S RD          ExplorePropertyId = 24393119
    5625 OVERBROOK LN
    100 METEOR DR
*/

function SearchManager({ mapReady, searchPin, mapActions, dataActions, mapRef, setExploreSearch, setExploreSearchPin, isMobile }) {
  const classes = useStyles();
  const searchBoxRef = useRef(null);
  const inputRef = useRef(null);
  const containerRef = useRef(null);
  const [map, setMap] = useState(mapRef.current);
  useEffect(() => {
    setMap(mapRef.current);
  }, [mapRef]);
  function onLoad(ref) {
    searchBoxRef.current = ref;
    // console.log(searchBoxRef.firstChild)
    mapRef.current.controls[google.maps.ControlPosition.TOP_RIGHT].push(containerRef.current);
  }

  function onPlacesChanged() {
    const places = searchBoxRef.current.getPlaces();
    const bounds = new google.maps.LatLngBounds();

    places.forEach(place => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport)
      } else {
        bounds.extend(place.geometry.location)
      }
    });
    const nextMarkers = places.map(place => ({
      position: place.geometry.location,
    }));
    const nextCenter = _.get(nextMarkers, '0.position', map.center);

    if (places && places.length === 1) {
      var place = places[0];
      if (place.address_components) {
        finalizeSearch(place, nextCenter, bounds);
      } else if (place.place_id) { //have to do this when no address_components returned on initial search
        var service = new google.maps.places.PlacesService(map);
        var request = { placeId: place.place_id };
        service.getDetails(request, function (placeDetailed, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            finalizeSearch(placeDetailed, nextCenter, bounds);
          }
        });
      }
    }

    //other map positioning options:
    /*
      map.setCenter(nextCenter);
      map.fitBounds(bounds);
      map.panToBounds(bounds);
      map.panTo(nextMarkers[0].position);
    */
  }

  function finalizeSearch(place, nextCenter, bounds) {
    const forceSearchSet = map.getCenter().equals(nextCenter);
    var cluster = parseGooglePlace(place);
    if (cluster.zoom) {
      map.zoom = cluster.zoom;
      map.setCenter(nextCenter);
    } else {
      fitBoundsWithZoom(map, bounds);
    }
    cluster.lat = nextCenter.lat();
    cluster.lng = nextCenter.lng();
    
    setExploreSearch(cluster, forceSearchSet);
  }

  function onClearSearch() {
    inputRef.current.value = null;
    setExploreSearchPin(null);
  }

  if (!mapReady) return null;
  return (
    <StandaloneSearchBox
      onLoad={onLoad}
      //bounds={props.bounds}
      onPlacesChanged={onPlacesChanged}
    >
      <div ref={containerRef} style={isMobile ? { position: 'absolute', display: 'flex', width: 'calc(100% - 65px)', justifyContent: 'center', alignItems: 'center' } : { position: 'absolute' }}>
        <input
          type="text"
          ref={inputRef}
          //onChange={onSearchChange}
          placeholder="Search ..."          
          className={searchPin && inputRef?.current?.value !== '' ? classes.enabledBox : classes.normalBox}
        />
        <IconButton className={isMobile ? classes.clearButtonMobile : classes.clearButton} onClick={onClearSearch}>
          <ClearIcon fontSize="inherit" />
        </IconButton>
      </div>
    </StandaloneSearchBox>
  )
}

function mapState({ exploreMap, appState }) {
  return {
    mapReady: exploreMap.bounds !== null && exploreMap.bounds !== undefined,
    searchPin: exploreMap.searchPin,
    isMobile: appState.isMobile,
  };
}

const mapDispatch = {
  setExploreSearch,
  setExploreSearchPin
}

export default compose(
    connect(mapState, mapDispatch)
)(SearchManager);
